import Tr from 'translations/Translations';

export const CRYTERIUM_TYPE = {
	TIME_LIMIT: "TIME_LIMIT",
	GUARANTEE: "GUARANTEE",
	PAYMENT: "PAYMENT",
	OPERATING_COST: "OPERATING_COST",
	SERVICE: "SERVICE",
	CONTRACT_SECURITY: "CONTRACT_SECURITY",
	OWNERSHIP: "OWNERSHIP",
	OTHER: "OTHER",
	PRICE: "PRICE",
}

export const CRYTERIUM_TYPE_LABEL = {
	[CRYTERIUM_TYPE.CONTRACT_SECURITY]: Tr('criterion_type_contract_security'),
	[CRYTERIUM_TYPE.GUARANTEE]: Tr('criterion_type_guarantee'),
	[CRYTERIUM_TYPE.OPERATING_COST]: Tr('criterion_type_operating_cost'),
	[CRYTERIUM_TYPE.OWNERSHIP]: Tr('criterion_type_ownership'),
	[CRYTERIUM_TYPE.PAYMENT]: Tr('criterion_type_payment'),
	[CRYTERIUM_TYPE.PRICE]: Tr('criterion_type_price'),
	[CRYTERIUM_TYPE.SERVICE]: Tr('criterion_type_service'),
	[CRYTERIUM_TYPE.TIME_LIMIT]: Tr('criterion_type_time_limit'),
	[CRYTERIUM_TYPE.OTHER]: Tr('other'),
}

const createItem = (key) => ({
	label: CRYTERIUM_TYPE_LABEL[key],
	value: key
})

export default Object.values(CRYTERIUM_TYPE).map( x => createItem(x))